var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm.reservation && _vm.reservation.show
                        ? _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h2", { staticClass: "mb-3" }, [
                                      _vm._v("Reservation Cancelled"),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "All prices are in " +
                                          _vm._s(
                                            _vm.reservation.hotel.hotel_name
                                          ) +
                                          "'s local currency " +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_name
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.reservation.hotel.currency
                                      .currency_code != "GBP"
                                      ? _c("p", [
                                          _vm._v(
                                            "Exchange rate for this record: " +
                                              _vm._s(
                                                _vm.reservation
                                                  .quote_exchange_rate
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.reservation.hotel.currency
                                                  .currency_code
                                              ) +
                                              " to 1 GBP"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "3" } },
                                    [_c("strong", [_vm._v("Total Rate:")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "9" } },
                                    [
                                      _vm._v(
                                        "\n                                  " +
                                          _vm._s(
                                            _vm.reservation.quote_amount_local
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_code
                                          ) +
                                          "\n                              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "3" } },
                                    [_c("strong", [_vm._v("Quote:")])]
                                  ),
                                  _vm._v(" "),
                                  _vm.units.length
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "9" } },
                                        _vm._l(
                                          _vm.units,
                                          function (unit, index) {
                                            return _c("div", [
                                              _c(
                                                "fieldset",
                                                [
                                                  _c("legend", [
                                                    _vm._v(
                                                      "Unit " +
                                                        _vm._s(index + 1) +
                                                        ": " +
                                                        _vm._s(
                                                          unit.roomTypeName
                                                        )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { row: "" } },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                   " +
                                                              _vm._s(
                                                                unit.guests
                                                                  .adults
                                                                  ? unit.guests
                                                                      .adults +
                                                                      " adults"
                                                                  : ""
                                                              ) +
                                                              "\n                                                   " +
                                                              _vm._s(
                                                                unit.guests
                                                                  .olderChildren
                                                                  ? unit.guests
                                                                      .olderChildren +
                                                                      " older children"
                                                                  : ""
                                                              ) +
                                                              "\n                                                   " +
                                                              _vm._s(
                                                                unit.guests
                                                                  .youngChildren
                                                                  ? unit.guests
                                                                      .youngChildren +
                                                                      " children"
                                                                  : ""
                                                              ) +
                                                              "\n                                                   " +
                                                              _vm._s(
                                                                unit.guests
                                                                  .babies
                                                                  ? unit.guests
                                                                      .babies +
                                                                      " babies"
                                                                  : ""
                                                              ) +
                                                              ",\n                                                   " +
                                                              _vm._s(
                                                                unit.rateTypeName
                                                              ) +
                                                              "\n                                            "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pa-1",
                                                          attrs: {
                                                            cols: "6",
                                                            md: "3",
                                                          },
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v("Date"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pa-1",
                                                          attrs: {
                                                            cols: "6",
                                                            md: "3",
                                                          },
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              "Rate Amount (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .reservation
                                                                    .hotel
                                                                    .currency
                                                                    .currency_code
                                                                ) +
                                                                ")"
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pa-1",
                                                          attrs: {
                                                            cols: "6",
                                                            md: "3",
                                                          },
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              "Commission %"
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pa-1",
                                                          attrs: {
                                                            cols: "6",
                                                            md: "3",
                                                          },
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              "Commission Amount (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .reservation
                                                                    .hotel
                                                                    .currency
                                                                    .currency_code
                                                                ) +
                                                                ")"
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        unit.pricesPerDate,
                                                        function (datePrice) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    row: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-1",
                                                                      attrs: {
                                                                        cols: "6",
                                                                        md: "3",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            _vm.dateFormatDDMYYYYDay(
                                                                              datePrice.date
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-1",
                                                                      attrs: {
                                                                        cols: "6",
                                                                        md: "3",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            datePrice.rateAmount.toFixed(
                                                                              2
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-1",
                                                                      attrs: {
                                                                        cols: "6",
                                                                        md: "3",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            datePrice.commissionPercentage
                                                                          ) +
                                                                          "\n                                                    "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-1",
                                                                      attrs: {
                                                                        cols: "6",
                                                                        md: "3",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            datePrice.commissionAmounttoFixed(
                                                                              2
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "3" } },
                                    [_c("strong", [_vm._v("Taxes and Fees:")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "9" } },
                                    _vm._l(
                                      _vm.reservation.additional_fees,
                                      function (fee, index) {
                                        return _c(
                                          "fieldset",
                                          [
                                            _c("legend", [
                                              _vm._v(
                                                "Fee " +
                                                  _vm._s(index + 1) +
                                                  ": " +
                                                  _vm._s(fee.name)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                fee.description
                                                  ? _c(
                                                      "v-col",
                                                      { attrs: { cols: "12" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            fee.description
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _vm._v(
                                                      "\n                                           " +
                                                        _vm._s(fee.fee_value) +
                                                        " " +
                                                        _vm._s(
                                                          fee.fee_application_type ==
                                                            2
                                                            ? "%"
                                                            : _vm.reservation
                                                                .hotel.currency
                                                                .currency_code
                                                        ) +
                                                        "\n                                           " +
                                                        _vm._s(
                                                          _vm.feeCategoryAsString(
                                                            fee.hotel_additional_fee_type_key
                                                          )
                                                        ) +
                                                        ", \n                                           billed " +
                                                        _vm._s(
                                                          _vm.feeTypeAsString(
                                                            fee.fee_application_type
                                                          )
                                                        ) +
                                                        ",\n                                           payable to " +
                                                        _vm._s(
                                                          _vm.feePayableAsString(
                                                            fee.is_payable_to
                                                          )
                                                        ) +
                                                        "\n                                       "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [_vm._v("Deposit:")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "9" } }, [
                                    _vm.reservation.depositRequired
                                      ? _c("div", [
                                          _c("strong", [
                                            _vm._v(
                                              "Deposit required at time of booking " +
                                                _vm._s(
                                                  _vm.reservation
                                                    .deposit_amount_local
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.reservation.hotel.currency
                                                    .currency_code
                                                )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.reservation.is_advance_payment
                                      ? _c("div", [
                                          _vm._v(
                                            "Full pre-payment charged to the client by i-escape to secure the booking"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.reservation.is_advance_payment &&
                                    _vm.reservation.type_of_hotel == "UPF" &&
                                    _vm.reservation.hotel.collect_deposit == 1
                                      ? _c("div", [
                                          _vm._v(
                                            "Amount charged to the client by i-escape to secure the booking"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.reservation.is_advance_payment &&
                                    _vm.reservation.type_of_hotel == "ARR" &&
                                    !_vm.reservation.voucher_key
                                      ? _c("div", [
                                          _vm._v(
                                            "i-escape has not charged the clients card"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("strong", [
                                        _vm._v(
                                          "Balance payable to " +
                                            _vm._s(
                                              _vm.reservation.hotel.hotel_name
                                            ) +
                                            ":  " +
                                            _vm._s(
                                              _vm.reservation
                                                .quote_amount_local -
                                                _vm.reservation
                                                  .commission_amount_local
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.reservation.hotel.currency
                                                .currency_code
                                            )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [_vm._v("Payment Policy:")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        _vm._l(
                                          _vm.reservation.units,
                                          function (unit) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(unit.rate_type.name)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      unit.policy_payment_text
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [
                                      _vm._v("Cancellation Policy:"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        _vm._l(
                                          _vm.getCancellationPolicies(
                                            _vm.reservation
                                          ),
                                          function (policy) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("div", [
                                                  _c("strong", [
                                                    _vm._v(_vm._s(policy.name)),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(_vm._s(policy.text)),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.reservation.gift
                                    ? _c("v-col", { attrs: { cols: "3" } }, [
                                        _c("strong", [
                                          _vm._v("i-escape Gift:"),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.reservation.gift
                                    ? _c("v-col", { attrs: { cols: "9" } }, [
                                        _vm._v(
                                          "\n                                  " +
                                            _vm._s(_vm.reservation.gift) +
                                            "\n                              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-btn", { attrs: { href: "contactIescapeUrl" } }, [
                        _vm._v("Contact i-escape"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { href: _vm.addToCalendarUrl } },
                        [
                          _c("v-icon", [_vm._v("today")]),
                          _vm._v(" Update Calendar"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }